import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './css/ClassicClock.css';
import './css/ClassicClockPreview.css';

import Clock from 'react-clock';
import 'react-clock/dist/Clock.css';

const CornerClassicClock = ({ dimensions, area, timestamp, previewMode = false }) => {
    const [time, setTime] = useState(new Date(timestamp * 1000));
    const { clockSettings, clockDisplay } = useSelector((state) => state.apps);
    const [clockStyles, setClockStyles] = useState({
        faceColor: "#ffffff",
        borderColor: "#000",
        numberColor: clockSettings.text_color,
        numberSize: previewMode ? '1rem' : "min(0.2vw, 0.3vh)",
        hourHandColor: '#000',
        minuteHandColor: '#000',
        secondHandColor: 'red',
        size: previewMode ? 350 : "min(80vw, 80vh)"
    });

    const [areaHpx, setAreaHpx] = useState();
    const [areaWpx, setAreaWpx] = useState();
    const [Corner, setCorner] = useState(false);

    useEffect(() => {


        if (previewMode) {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
                const pxBasedSize = ((area.width / 100) * dimensions.width) * 0.80;
                const pxHBasedSize = ((area.height / 100) * dimensions.height) * 0.80;
                const calculatedSize = Math.min(pxBasedSize, pxHBasedSize);

                setClockStyles(prev => ({
                    ...prev,
                    size: `${calculatedSize}px`
                }));
            } else {
                setClockStyles(prev => ({
                    ...prev,
                    size: 350
                }));
            }
        } else {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));


                const pxBasedSize = ((area.width / 100) * dimensions.width) * 0.80;
                const pxHBasedSize = ((area.height / 100) * dimensions.height) * 0.80;
                const calculatedSize = Math.min(pxBasedSize, pxHBasedSize); setClockStyles(prev => ({
                    ...prev,
                    size: `${calculatedSize}px`
                }));

            } else {
                setClockStyles(prev => ({
                    ...prev,
                    size: "min(80vw, 80vh)"
                }));
            }
        }
    }, [area]);
    useEffect(() => {
        if (clockDisplay == "CORNER") {

            setCorner(true);

        }
    }, [clockDisplay]);




    // Create a controlled Date object
    const [controlledTime, setControlledTime] = useState(new Date());

    // Update time when timestamp changes
    useEffect(() => {
        const newTime = new Date(timestamp * 1000);
        setTime(newTime);
        updateControlledTime(newTime);
    }, [timestamp]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(prev => new Date(prev.getTime() + 1000));
            updateControlledTime(time);
        }, 1000);

        return () => clearInterval(interval);
    }, [time]);

    const updateControlledTime = (timeObj) => {

        const newControlledTime = new Date();

        newControlledTime.setHours(timeObj.getUTCHours());
        newControlledTime.setMinutes(timeObj.getMinutes());
        newControlledTime.setSeconds(timeObj.getSeconds());
        setControlledTime(newControlledTime);
    };


    useEffect(() => {
        setClockStyles(prev => ({
            ...prev,
            // faceColor: clockSettings.bg_color_flip,
            // borderColor: clockSettings.bg_color_sub,
            numberColor: clockSettings.text_color,
        }));
    }, [clockSettings])


    return (
        <div
            className={`flex justify-center align-items-center`}
            style={{
                backgroundColor: clockDisplay == "CORNER" ? 'transparent' : clockSettings.bg_color_main,
                width: previewMode ? "100%" : "100vw",
                height: previewMode ? "100%" : "100vh",
                fontSize: previewMode ? "1rem" : "1.5vw",
                color: clockSettings.text_color
            }}
        >
            {/* Clock Display */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: previewMode ? "100%" : "100vw",
                height: previewMode ? "100%" : "100vh",
            }}>
                <div style={{
                    width: clockStyles.size,
                    height: clockStyles.size,
                    position: 'relative'
                }}>
                    <Clock
                        value={controlledTime}
                        size={clockStyles.size}
                        renderNumbers={true}
                        className="custom-clock"
                    />

                    {/* Dynamic styles */}
                    <style>
                        {`
                            .custom-clock .react-clock__face {
                                background-color: ${clockStyles.faceColor};
                                border: 4px solid ${clockStyles.borderColor};
                            }
                            .custom-clock .react-clock__number {
                                color: ${clockStyles.numberColor};
                                font-size: ${clockStyles.numberSize};
                            }
                            .custom-clock .react-clock__hour-hand__body {
                                background-color: ${clockStyles.hourHandColor};
                            }
                            .custom-clock .react-clock__minute-hand__body {
                                background-color: ${clockStyles.minuteHandColor};
                            }
                            .custom-clock .react-clock__second-hand__body {
                                background-color: ${clockStyles.secondHandColor};
                            }
                        `}
                    </style>
                </div>
            </div>
        </div>
    );
};

export default CornerClassicClock;